<template>
  <AddEditCategoryForm :categoryDetails="categoryDetails" @onSuccess="getCategoryDetails"/>
</template>

<script>
import AddEditCategoryForm from '../../categories/components/AddEditCategoryForm.vue';

export default {
  name: 'CategoryDetailsUpdateCategory',
  components: {
    AddEditCategoryForm,
  },

  props: {
    categoryDetails: {
      type: Object,
      default: null,
      required: true,
    },
  },

  methods: {
    getCategoryDetails () {
      this.$emit('getCategoryDetails');
    },
  },
};
</script>
